/**
 * Shared One Verify network status rules constants (API/CSV sentinel, display copy).
 * App packages spread this into their `NETWORK_STATUS_CONFIG` and add env-specific fields.
 */
export const COMMON_ONE_VERIFY_NETWORK_STATUS_CONFIG = {
    /** CSV/API value for practice-wide rules (stored in `provider_npi` as this sentinel). */
    practiceWideProviderNpiSentinel: "PRACTICE",

    /** UI / table label when a rule applies to the entire practice (any provider NPI). */
    practiceWideProviderNpiLabel: "Practice-wide",
}
